import React from "react";
import MobileAccountList from "../components/MobileAccountList";
import { CreateAccountModal } from "../components/modals/CreateAccountModal";

const MobileAccountsPage = () => {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <CreateAccountModal isOpen={open} handleClose={handleClose} />
      <MobileAccountList openCreateAccountModal={handleOpen} />
    </div>
  );
};

export default MobileAccountsPage;
